/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { url } from 'inspector';
import { ViewProfileProps } from '../../components/investorOverview/types';
import { CALL_API } from '../middleware';
import { EnuinStatusObj, GETINVESTMENTDETAILTYPE, GetInvestmentUserDetails, GETOVERVIEW, GETREDEEMDETAILS, GETSWITCHDETAILTYPE, GETSWPDETAILTYPE, getTransactionStatusCheckBody, getTransactionStatusCheckRes, TransactionStatusObj } from '../types/api-types';
import {
  accessType,
  addFundType,
  addPlanType,
  ADD_FUND,
  ADD_FUND_SUCCESS,
  ADD_PLAN,
  ADD_PLAN_SUCCESS,
  ClassPlanProps,
  FundProps,
  GetFundsListResponseBody,
  GET_FUNDS,
  GET_FUNDS_ACCESS,
  GET_FUNDS_ACCESS_SUCCESS,
  GET_FUNDS_LIST,
  GET_FUNDS_LIST_SUCCESS,
  GET_FUNDS_SUCCESS,
  GET_PLAN_DETAILS,
  GET_PLAN_DETAILS_SUCCESS,
  GET_PLAN_SUCCESS,
  UPDATE_FUND,
  UPDATE_FUND_SUCCESS,
  UPDATE_PLAN,
  UPDATE_PLAN_SUCCESS,
  GET_RISK_PROFILE_CHECK_SUCCESS,
  GET_RISK_PROFILE_CHECK,
  GET_STP_WEEK_DAYS_SUCCESS,
  GET_STP_WEEK_DAYS,
  StpWeekDaysObj,
  GET_TRANSACTION_STATUS_SUCCESS,
  GET_TRANSACTION_STATUS,
  GET_EUIN_CHECK_SUCCESS,
  GET_EUIN_CHECK,
  GET_TRANSACTION_STATUS_CHECK_SUCCESS,
  GET_TRANSACTION_STATUS_CHECK,
} from '../types/funds';
import { method } from 'lodash';
import { encodeBase64 } from '../../utils/utilityFunctions';

export type fundsParams = {
  isActive?: boolean;
  trusteeId?: number;
  fundManagerId?: number;
};

export const getFundsList =
  (params?: fundsParams) =>
    async (dispatch: any): Promise<GetFundsListResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/funds/list`,
          method: 'GET',
          types: [GET_FUNDS_LIST_SUCCESS, GET_FUNDS_LIST],
          params,
        },
      });
    };

export const addFund =
  (body: addFundType) =>
    async (dispatch: any): Promise<FundProps[]> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/funds/addScheme`,
          method: 'POST',
          types: [ADD_FUND_SUCCESS, ADD_FUND],
          body,
        },
      });
    };

export const addPlan =
  (body: addPlanType) =>
    async (dispatch: any): Promise<ClassPlanProps[]> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/funds/addPlan`,
          method: 'POST',
          types: [ADD_PLAN_SUCCESS, ADD_PLAN],
          body,
        },
      });
    };

export const updateFund =
  (Id: number, body: any) =>
    async (dispatch: any): Promise<FundProps[]> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/funds/updateScheme/${Id}`,
          method: 'POST',
          types: [UPDATE_FUND_SUCCESS, UPDATE_FUND],
          body,
        },
      });
    };

export const updatePlan =
  (Id: number, body: any) =>
    async (dispatch: any): Promise<ClassPlanProps[]> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/funds/updatePlan/${Id}`,
          method: 'POST',
          types: [UPDATE_PLAN_SUCCESS, UPDATE_PLAN],
          body,
        },
      });
    };

export const fundAccess =
  () =>
    async (dispatch: any): Promise<accessType> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/funds/fundSetupAccess`,
          method: 'GET',
          types: [GET_FUNDS_ACCESS_SUCCESS, GET_FUNDS_ACCESS],
        },
      });
    };

export const getPlanList =
  (Id: string) =>
    async (dispatch: any): Promise<GetFundsListResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/funds/schemes/${Id}`,
          method: 'GET',
          types: [GET_PLAN_SUCCESS, GET_PLAN_SUCCESS],
        },
      });
    };

export const getPlanDetail =
  (Id: string) =>
    async (dispatch: any): Promise<ClassPlanProps[]> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/funds/plans/${Id}`,
          method: 'GET',
          types: [GET_PLAN_DETAILS_SUCCESS, GET_PLAN_DETAILS],
        },
      });
    };

export const getFunds =
  (params?: fundsParams) =>
    async (dispatch: any): Promise<GetFundsListResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/funds`,
          method: 'GET',
          types: [GET_FUNDS_SUCCESS, GET_FUNDS],
          params,
        },
      });
    };

export const getInvestmentDetails =
  (body: { schemeIds: string[], portfolioId: string, schemeDetails?: any, clientCode: string, rmId: string; }) =>
    async (dispath: any): Promise<GETINVESTMENTDETAILTYPE> => {
      return await dispath({
        [CALL_API]: {
          // enableFixture: true,
          // json: 'investmentDetails.json',
          url: '/onboarding/transactions/sendScheme',
          types: [GET_FUNDS_SUCCESS, GET_FUNDS],
          method: 'POST',
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        }
      })
    }
export const getInvestmentUserDetails =
  (body: { clientCode?: string, portfolioId?: string, temporaryToken?: string }) =>
    async (dispath: any): Promise<GetInvestmentUserDetails> => {
      return await dispath({
        [CALL_API]: {
          // enableFixture: true,
          // json: 'investmentDetails.json',
          url: '/onboarding/applications/getInvestorDetailsForCart',
          types: [GET_FUNDS_SUCCESS, GET_FUNDS],
          method: 'POST',
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          temporaryToken: body?.temporaryToken ?? "",
        }
      })
    }

export const submitInvestmentDetails =
  (body: any) =>
    async (dispath: any): Promise<any> => {
      return await dispath({
        [CALL_API]: {
          // enableFixture: true,
          // json: 'investmentDetails.json',
          url: '/onboarding/transactions/placeOrder',
          types: [GET_FUNDS_SUCCESS, GET_FUNDS],
          method: 'POST',
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        }
      })
    }

export const getRiskProfileCheck =
  (body: any) =>
    async (dispath: any): Promise<any> => {
      return await dispath({
        [CALL_API]: {
          url: '/onboarding/transactions/riskProfileCheck',
          types: [GET_RISK_PROFILE_CHECK_SUCCESS, GET_RISK_PROFILE_CHECK],
          method: 'POST',
          // body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          body
        }
      })
    }

export const submitRecomment =
  (body: any) =>
    async (dispath: any): Promise<any> => {
      return await dispath({
        [CALL_API]: {
          // enableFixture: true,
          // json: 'investmentDetails.json',
          url: '/onboarding/transactions/addRecommendationData',
          types: [GET_FUNDS_SUCCESS, GET_FUNDS],
          method: 'POST',
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        }
      })
    }
export const getInvestmore =
  () =>
    async (dispath: any): Promise<GETINVESTMENTDETAILTYPE> => {
      return await dispath({
        [CALL_API]: {
          enableFixture: true,
          json: 'investmentDetails.json',
          // url: '/onboarding/transactions/sendScheme',
          types: [GET_FUNDS_SUCCESS, GET_FUNDS],
          // method: 'POST',
          // body,
        }
      })
    }
export const getRedeemDetails =
  () =>
    async (dispath: any): Promise<GETREDEEMDETAILS> => {
      return await dispath({
        [CALL_API]: {
          enableFixture: true,
          json: 'investementRedeem.json',
          types: [GET_FUNDS_SUCCESS, GET_FUNDS]
        }
      })
    }
export const getSwitchFundDetails =
  () =>
    async (dispath: any): Promise<GETSWITCHDETAILTYPE> => {
      return await dispath({
        [CALL_API]: {
          enableFixture: true,
          json: 'switch.json',
          types: [GET_FUNDS_SUCCESS, GET_FUNDS]
        }
      })
    }
export const getSwpDetails =
  () =>
    async (dispath: any): Promise<GETSWPDETAILTYPE> => {
      return await dispath({
        [CALL_API]: {
          enableFixture: true,
          json: 'swp.json',
          types: [GET_FUNDS_SUCCESS, GET_FUNDS]
        }
      })
    }

export const getOverViewDetails = () => async (dispatch: any): Promise<GETOVERVIEW> => {
  return await dispatch({
    [CALL_API]: {
      enableFixture: true,
      json: 'overview.json',
      types: [GET_FUNDS_SUCCESS, GET_FUNDS]
    }
  })
}

export const viewProfileDetails = () => async (dispatch: any): Promise<ViewProfileProps> => {
  return await dispatch({
    [CALL_API]: {
      enableFixture: true,
      json: 'viewProfile.json',
      types: [GET_FUNDS_SUCCESS, GET_FUNDS]
    }
  })
}


export const getOrderDetails = (body: {
  clientCode?: string,
  currentPage?: number,
  searchInput?: string,
  trType?: Array<string | number>,
  status?: Array<string | number>
}) => async (dispatch: any): Promise<{ orders: Array<any> }> => {
  return await dispatch({
    [CALL_API]: {
      // enableFixture: true,
      url: '/onboarding/transactions/ordersList',
      json: 'viewProfile.json',
      method: "POST",
      body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
      types: [GET_FUNDS_SUCCESS, GET_FUNDS]
    }
  })
}

export const getIndividualOrder = (body: { id: string | number, portfolioId: string }) => async (dispatch: any): Promise<any> => {
  return await dispatch({
    [CALL_API]: {
      // enableFixture: true,
      url: '/onboarding/transactions/individual-order-details',
      json: 'viewProfile.json',
      method: "POST",
      body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
      types: [GET_FUNDS_SUCCESS, GET_FUNDS]
    }
  })
}

export const getOrderType = () => async (dispatch: any): Promise<Array<any>> => {
  return await dispatch({
    [CALL_API]: {
      // enableFixture: true,
      url: '/onboarding/transactions/getOrderTypeFilter',
      json: 'viewProfile.json',
      method: "POST",
      types: [GET_FUNDS_SUCCESS, GET_FUNDS]
    }
  })
}
export const getOrderStatus = () => async (dispatch: any): Promise<Array<any>> => {
  return await dispatch({
    [CALL_API]: {
      // enableFixture: true,
      url: '/onboarding/transactions/getOrderStatusFilter',
      json: 'viewProfile.json',
      method: "POST",
      types: [GET_FUNDS_SUCCESS, GET_FUNDS]
    }
  })
}

export const getStpWeekDays =
  () =>
    async (dispatch: any): Promise<Array<StpWeekDaysObj>> => {
      return await dispatch({
        [CALL_API]: {
          url: `/mdms/weekly_stp_dates.json`,
          method: 'GET',
          types: [GET_STP_WEEK_DAYS_SUCCESS, GET_STP_WEEK_DAYS],
        },
      });
    };

export const getTransactionStatus =
  (body: { clientCode: string }) =>
    async (dispatch: any): Promise<Array<TransactionStatusObj>> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/applications/transaction-status/${body.clientCode}`,
          method: 'GET',
          types: [GET_TRANSACTION_STATUS_SUCCESS, GET_TRANSACTION_STATUS],
        },
      });
    };

export const euinCheck =
  (body: { rmId: string }) =>
    async (dispatch: any): Promise<EnuinStatusObj> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/transactions/rm-validity-check`,
          method: 'POST',
          types: [GET_EUIN_CHECK_SUCCESS, GET_EUIN_CHECK],
          body
        },
      });
    };

export const getTransactionStatusCheck =
  (body: getTransactionStatusCheckBody) =>
    async (dispatch: any): Promise<getTransactionStatusCheckRes> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/transactions/validate-transaction`,
          method: 'POST',
          types: [GET_TRANSACTION_STATUS_CHECK_SUCCESS, GET_TRANSACTION_STATUS_CHECK],
          body
        },
      });
    };